import { useState, useCallback } from 'react';

export function useQuizTimer(start = true) {
  const [isTimerActive, setIsTimerActive] = useState(start);

  const pauseTimer = useCallback(() => {
    setIsTimerActive(false);
  }, []);

  const resumeTimer = useCallback(() => {
    setIsTimerActive(true);
  }, []);

  const resetTimer = useCallback(() => {
    setIsTimerActive(true);
  }, []);

  return {
    isTimerActive,
    pauseTimer,
    resumeTimer,
    resetTimer,
  };
}
